import React from "react";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import styles from "./PeriodSelector.module.scss";
import moment from "moment";
import { IDateHandlerObject } from "../../types";
import {
  getPeriodType,
  getPreviousFromDate,
  newHandleCurrentDate,
  newHandleNextDateSelection,
  newHandlePreviousDateSelection,
} from "../../functions/dateFunctions";
import Typography from "@material-ui/core/Typography";
import { t } from "i18next";

interface ISelectPeriod {
  onChange: (dataObjForDetailComponent: IDateHandlerObject) => void;
  dataHandlerObject: IDateHandlerObject;
  occupationDate?: number;
}
const PeriodSelector = ({
  onChange,
  dataHandlerObject,
  occupationDate,
}: ISelectPeriod) => {
  const handlePeriod = (date: string, type: "previous" | "next") => {
    const datePeriod = getPeriodType(date);
    if (type === "previous") {
      const period = {
        period: dataHandlerObject.period,
        from: moment(dataHandlerObject.from)
          .subtract(1, datePeriod)
          .startOf(datePeriod),
        to: moment(dataHandlerObject.to)
          .subtract(1, datePeriod)
          .endOf(datePeriod),
      };
      onChange(period);
      return;
    }
    const period = {
      period: dataHandlerObject.period,
      from: moment(dataHandlerObject.from)
        .add(1, datePeriod)
        .startOf(datePeriod),
      to: moment(dataHandlerObject.to).add(1, datePeriod).endOf(datePeriod),
    };
    onChange(period);
  };
  return (
    <div className={styles.container}>
      {!occupationDate ||
      occupationDate < getPreviousFromDate(dataHandlerObject) ? (
        <div
          onClick={() => handlePeriod(dataHandlerObject.period, "previous")}
          className={styles.periodSelection}
        >
          <NavigateBeforeIcon fontSize="small" htmlColor="#FFFFFF" />
          <Typography
            align="center"
            variant="body2"
            className={styles.chooseDateButton}
          >
            {newHandlePreviousDateSelection(dataHandlerObject)}
          </Typography>
        </div>
      ) : (
        <div className={styles.periodSelection}>
          <NavigateBeforeIcon fontSize="small" htmlColor="primary" />
          <Typography
            align="center"
            variant="body2"
            className={styles.chooseDateButton}
          >
            {t("unavailable")}
          </Typography>
        </div>
      )}
      <div className={styles.selectedPeriod}>
        <Typography align="center" variant="body2">
          {newHandleCurrentDate(dataHandlerObject)}
        </Typography>
      </div>
      <div
        onClick={() => handlePeriod(dataHandlerObject.period, "next")}
        className={styles.periodSelection}
      >
        <Typography
          align="center"
          variant="body2"
          className={styles.chooseDateButton}
        >
          {newHandleNextDateSelection(dataHandlerObject)}
        </Typography>
        <NavigateNextIcon fontSize="small" htmlColor="#FFFFFF" />
      </div>
    </div>
  );
};

export default PeriodSelector;
